import {
  IAcademicsSchedule,
  EScheduleType,
  EWeekDay,
  EBreakType,
  ISchedulePeriod,
} from '../../apis/academics/academicsSchedules.interfaces';

// Generate some period data for a schedule
const generatePeriods = (
  scheduleId: string,
  classId: number,
  teacherId: number
): ISchedulePeriod[] => {
  const periods: ISchedulePeriod[] = [];

  // Create periods for each day of the week
  Object.values(EWeekDay).forEach((day) => {
    // Regular class periods
    for (let i = 1; i <= 6; i++) {
      const periodId = `${scheduleId}_${day}_${i}`;
      const startHour = 8 + Math.floor((i - 1) / 2);
      const startMinute = ((i - 1) % 2) * 30;
      const endHour = 8 + Math.floor(i / 2);
      const endMinute = (i % 2) * 30;

      // Every third period is a break
      if (i % 3 === 0) {
        periods.push({
          id: periodId,
          periodNumber: i,
          startTime: `${startHour.toString().padStart(2, '0')}:${startMinute.toString().padStart(2, '0')}`,
          endTime: `${endHour.toString().padStart(2, '0')}:${endMinute.toString().padStart(2, '0')}`,
          dayOfWeek: day,
          isBreak: true,
          breakType: i === 3 ? EBreakType.LUNCH : EBreakType.SHORT_BREAK,
        });
      } else {
        // Regular class period
        const courseId = 100 + ((i + day.length) % 5); // Generate different course IDs

        periods.push({
          id: periodId,
          periodNumber: i,
          startTime: `${startHour.toString().padStart(2, '0')}:${startMinute.toString().padStart(2, '0')}`,
          endTime: `${endHour.toString().padStart(2, '0')}:${endMinute.toString().padStart(2, '0')}`,
          dayOfWeek: day,
          courseId,
          teacherId: teacherId + (i % 3), // Rotate between a few teachers
          classId,
          room: `Room ${200 + (i % 10)}`,
          isBreak: false,
        });
      }
    }
  });

  return periods;
};

export const mockAcademicsSchedules: IAcademicsSchedule[] = [
  {
    id: '1',
    name: 'Regular Class Schedule - Grade 8',
    description: 'Standard weekly schedule for Grade 8',
    createdAt: '2021-01-01',
    updatedAt: '2021-01-01',
    type: EScheduleType.REGULAR,
    academicYear: '2023-2024',
    isActive: true,
    periods: generatePeriods('1', 101, 201),
  },
  {
    id: '2',
    name: 'Mid-Term Examination Schedule',
    description: 'Mid-term exam schedule for all classes',
    createdAt: '2021-01-02',
    updatedAt: '2021-01-02',
    type: EScheduleType.EXAM,
    academicYear: '2023-2024',
    isActive: true,
    periods: generatePeriods('2', 102, 202),
  },
  {
    id: '3',
    name: 'Science Fair Schedule',
    description: 'Special event schedule for the annual science fair',
    createdAt: '2021-01-03',
    updatedAt: '2021-01-03',
    type: EScheduleType.SPECIAL_EVENT,
    academicYear: '2023-2024',
    isActive: false,
    periods: generatePeriods('3', 103, 203),
  },
  {
    id: '4',
    name: 'Holiday Schedule - Winter Break',
    description: 'Winter break schedule',
    createdAt: '2021-01-04',
    updatedAt: '2021-01-04',
    type: EScheduleType.HOLIDAY,
    academicYear: '2023-2024',
    isActive: true,
    periods: [],
  },
  {
    id: '5',
    name: 'Regular Class Schedule - Grade 9',
    description: 'Standard weekly schedule for Grade 9',
    createdAt: '2021-01-05',
    updatedAt: '2021-01-05',
    type: EScheduleType.REGULAR,
    academicYear: '2023-2024',
    isActive: true,
    periods: generatePeriods('5', 104, 204),
  },
  {
    id: '6',
    name: 'Final Examination Schedule',
    description: 'Final exam schedule for all classes',
    createdAt: '2021-01-06',
    updatedAt: '2021-01-06',
    type: EScheduleType.EXAM,
    academicYear: '2023-2024',
    isActive: true,
    periods: generatePeriods('6', 105, 205),
  },
  {
    id: '7',
    name: 'Sports Day Schedule',
    description: 'Special event schedule for the annual sports day',
    createdAt: '2021-01-07',
    updatedAt: '2021-01-07',
    type: EScheduleType.SPECIAL_EVENT,
    academicYear: '2023-2024',
    isActive: false,
    periods: [],
  },
  {
    id: '8',
    name: 'Holiday Schedule - Summer Break',
    description: 'Summer break schedule',
    createdAt: '2021-01-08',
    updatedAt: '2021-01-08',
    type: EScheduleType.HOLIDAY,
    academicYear: '2023-2024',
    isActive: true,
    periods: [],
  },
  {
    id: '9',
    name: 'Regular Class Schedule - Grade 10',
    description: 'Standard weekly schedule for Grade 10',
    createdAt: '2021-01-09',
    updatedAt: '2021-01-09',
    type: EScheduleType.REGULAR,
    academicYear: '2023-2024',
    isActive: true,
    periods: generatePeriods('9', 106, 206),
  },
  {
    id: '10',
    name: 'Practice Test Schedule',
    description: 'Practice test schedule before final exams',
    createdAt: '2021-01-10',
    updatedAt: '2021-01-10',
    type: EScheduleType.EXAM,
    academicYear: '2023-2024',
    isActive: true,
    periods: generatePeriods('10', 107, 207),
  },
  {
    id: '11',
    name: 'Cultural Festival Schedule',
    description: 'Special event schedule for the cultural festival',
    createdAt: '2021-01-11',
    updatedAt: '2021-01-11',
    type: EScheduleType.SPECIAL_EVENT,
    academicYear: '2023-2024',
    isActive: false,
    periods: [],
  },
  {
    id: '12',
    name: 'Regular Class Schedule - Grade 11',
    description: 'Standard weekly schedule for Grade 11',
    createdAt: '2021-01-12',
    updatedAt: '2021-01-12',
    type: EScheduleType.REGULAR,
    academicYear: '2023-2024',
    isActive: true,
    periods: generatePeriods('12', 108, 208),
  },
  {
    id: '13',
    name: 'Mock Examination Schedule',
    description: 'Mock exam schedule for board preparation',
    createdAt: '2021-01-13',
    updatedAt: '2021-01-13',
    type: EScheduleType.EXAM,
    academicYear: '2023-2024',
    isActive: false,
    periods: [],
  },
  {
    id: '14',
    name: 'Holiday Schedule - Spring Break',
    description: 'Spring break schedule',
    createdAt: '2021-01-14',
    updatedAt: '2021-01-14',
    type: EScheduleType.HOLIDAY,
    academicYear: '2023-2024',
    isActive: true,
    periods: [],
  },
  {
    id: '15',
    name: 'Annual Day Schedule',
    description: 'Special event schedule for the annual day celebration',
    createdAt: '2021-01-15',
    updatedAt: '2021-01-15',
    type: EScheduleType.SPECIAL_EVENT,
    academicYear: '2023-2024',
    isActive: false,
    periods: [],
  },
];

// Add more schedules as needed to match the original count
for (let i = 16; i <= 31; i++) {
  mockAcademicsSchedules.push({
    id: i.toString(),
    name: `Schedule ${i}`,
    description: `Description ${i}`,
    createdAt: `2021-01-${i}`,
    updatedAt: `2021-01-${i}`,
    type: [
      EScheduleType.REGULAR,
      EScheduleType.EXAM,
      EScheduleType.SPECIAL_EVENT,
      EScheduleType.HOLIDAY,
    ][i % 4],
    academicYear: '2023-2024',
    isActive: i % 2 === 0,
    periods: [],
  });
}
